import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get vessel claims
 * */
export function* getVesselClaims() {
    const response = yield call(api.getVesselClaims);
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_VESSEL_CLAIMS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_VESSEL_CLAIMS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetVesselClaims() {
    while (true) {
        yield take(actionTypes.GET_VESSEL_CLAIMS.REQUEST);
        yield fork(getVesselClaims);
    }
}

/**
 * Reject vessel claims to user
 * */
export function* rejectUserClaimsToVessel(userId, vesselId) {
    const response = yield call(api.rejectUserClaimsToVessel, userId, vesselId);
    if (response.status === 200) {
        yield put({
            type: actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.SUCCESS,
            userId,
            vesselId,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.FAILURE,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });

    return response;
}

export function* watchRejectUserClaimsToVessel() {
    while (true) {
        const { userId, vesselId } = yield take(actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.REQUEST);
        yield fork(rejectUserClaimsToVessel, userId, vesselId);
    }
}

/**
 * Accept vessel claims to user
 * */
export function* acceptUserClaimsToVessel(userId, vesselId) {
    const response = yield call(api.acceptUserClaimsToVessel, userId, vesselId);
    if (response.status === 200) {
        yield put({
            type: actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.SUCCESS,
            userId,
            vesselId,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.FAILURE,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });
}

export function* watchAcceptUserClaimsToVessel() {
    while (true) {
        const { userId, vesselId } = yield take(actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.REQUEST);
        yield fork(acceptUserClaimsToVessel, userId, vesselId);
    }
}

export default [
    watchGetVesselClaims,
    watchRejectUserClaimsToVessel,
    watchAcceptUserClaimsToVessel,
];



// WEBPACK FOOTER //
// ./app/sagas/vessels/claims.js